module.exports = __webpack_public_path__ + "static/media/galeriaperiodistica.09281ac3.webp";